<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Preface">Preface</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. H.H. Holmes, America’s First Serial Killer</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. Lucy Lambert Hale</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Governor Wentworth’s Wedding</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. Judge John Pickering</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Isles of Shoals</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Lovewell’s War</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. America’s Stonehenge</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Mystery Stone</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. Old Man in the Mountain</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. Rock Rimmon</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. Cemeteries</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. Aleister Crowley’s Retirement</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. <i>Peyton Place</i></span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. J.D. Salinger</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">15. The Hanging of Ruth Blay</span></p>
<p class="toc"><span href="#/Chapter16#C16" title="Link target outside of Sample">16. The Murder of Josie Langmaid</span></p>
<p class="toc"><span href="#/Chapter17#C17" title="Link target outside of Sample">17. The Overdue Library Book</span></p>
<p class="toc"><span href="#/Chapter18#C18" title="Link target outside of Sample">18. Madame Sherri</span></p>
<p class="toc"><span href="#/Chapter19#C19" title="Link target outside of Sample">19. The Frog Eater</span></p>
<p class="toc"><span href="#/Chapter20#C20" title="Link target outside of Sample">20. The Fireman’s Riot</span></p>
<p class="toc"><span href="#/Chapter21#C21" title="Link target outside of Sample">21. Suspected Witchcraft</span></p>
<p class="toc"><span href="#/Chapter22#C22" title="Link target outside of Sample">22. The Murder of Jonas L. Parker</span></p>
<p class="toc1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?531afe33